import { Button, Modal } from "antd";
import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import "./ImageCropper.scss";
import Helpers from "@utils/Helpers";

const ImageCropper: React.FC<any> = ({
  isOpenCropper,
  closeCropper,
  selectedImg,
  onComplete,
  type,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((_: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = async () => {
    const croppedImage = await Helpers.getCroppedImg(
      selectedImg.url,
      croppedAreaPixels
    );
    onComplete(croppedImage, selectedImg.documentId);
  };

  return (
    <Modal
      className="ImageCropper"
      open={isOpenCropper}
      onCancel={closeCropper}
      onOk={handleCrop}
    >
      <div style={{ width: 400, height: 300, position: "relative" }}>
        <Cropper
          image={selectedImg.url}
          crop={crop}
          zoom={zoom}
          aspect={type == "avatar" ? 1 : 7.25 / 1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      </div>
    </Modal>
  );
};

export default ImageCropper;
